import { Close } from '@mui/icons-material';
import AutoAwesome from '@mui/icons-material/AutoAwesome';
import Edit from '@mui/icons-material/Edit';
import { DialogContent, Tabs, styled } from '@mui/material';

// Semantic design tokens. Will consider lifting to a shared theme file once reused outside decision support.
export const NEUTRAL_BLUE = '#344054';
export const SURFACE_GRAY = '#F6F8FA';
export const SYSTEM_BLUE = '#5686BD';
export const BORDER_GRAY = '#D0D5DD';
export const BORDER_RADIUS_SM_PX = 4;

export const StyledDecisionSupport = styled('div')`
    display: flex;

    & > button {
        padding: 0.3rem;
    }
`;

export const StyledEdit = styled(Edit)`
    width: 16px;
    height: 16px;
`;

export const StyledClose = styled(Close)`
    width: 16px;
    height: 16px;
`;

export const StyledDialogContent = styled(DialogContent)`
    padding-left: 0;
    padding-right: 0;
`;

export const StyledAutoAwesome = styled(AutoAwesome)`
    height: 20px;
    width: 20px;
`;

export const StyledField = styled('div')`
    display: flex;
    align-items: center;
    gap: 1rem;
`;

export const StyledDecisionSupportTabs = styled(Tabs)`
    & .MuiTabs-indicator {
        display: none;
    }
    & .MuiTab-root {
        background-color: ${SURFACE_GRAY};
        border: 1px solid transparent;
        border-bottom: none;
        border-top-left-radius: ${BORDER_RADIUS_SM_PX}px;
        border-top-right-radius: ${BORDER_RADIUS_SM_PX}px;
        text-transform: none;
    }
    & .MuiTab-root.Mui-selected {
        background-color: #ffffff;
        border: 1px solid ${BORDER_GRAY};
    }
    & .MuiTab-root:nth-of-type(1),
    & .MuiTab-root:nth-of-type(1).Mui-selected {
        color: ${NEUTRAL_BLUE};
    }
    & .MuiTab-root:nth-of-type(2),
    & .MuiTab-root:nth-of-type(2).Mui-selected {
        color: ${SYSTEM_BLUE};
    }
`;
